import { RootState } from "@redux/app/store"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { type PartialWebPortalWarningMessage } from "open-lib"

type State = {
	isConnected: boolean
	warningPanelHeight: number
	warningMessage?: PartialWebPortalWarningMessage | null
}

export const defaultState: State = {
	isConnected: false,
	warningPanelHeight: 0,
	warningMessage: undefined,
}

const appStateSlice = createSlice({
	initialState: defaultState,
	name: "appState",
	reducers: {
		updateIsConnected(state, action: PayloadAction<boolean>) {
			return { ...state, isConnected: action.payload }
		},
		setWarningMessage(state, action: PayloadAction<PartialWebPortalWarningMessage | null>) {
			return { ...state, warningMessage: action.payload }
		},
		setWarningPanelHeight(state, action: PayloadAction<number>) {
			return { ...state, warningPanelHeight: action.payload }
		},
	},
})

export const getWarningMessage = (state: RootState) => state.appState.warningMessage
export const getWarningPanelHeight = (state: RootState) => state.appState.warningPanelHeight

export const { updateIsConnected, setWarningMessage, setWarningPanelHeight } = appStateSlice.actions
export default appStateSlice.reducer
